module.exports = fox._r("images/preloader-conic.png", __webpack_public_path__ + "_/_/_/common/frame/images/preloader-conic.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/preloader-conic.png
// module id = 19
// module chunks = 2